import { Dialog, DialogTitle, DialogContent, Typography, DialogActions, Button, Divider } from "@mui/material"

interface Props {
    open: boolean,
    onClose: () => void
}


const pStyle : React.CSSProperties = {
    fontSize: 20,
    fontFamily: '"Berkshire Swash", "Georgia", serif',
    lineHeight: 1.4,
    hyphens: 'auto',
};

const pStyleJustified: React.CSSProperties = {
    ...pStyle,
    textAlign: 'justify'
};

const aStyle: React.CSSProperties = {
    color: "#17324b",
    textDecoration: "underline",
    textDecorationStyle: "dotted",
    textUnderlineOffset: "3px",
    cursor: "pointer",
}

export default function AboutUsDialog({ open, onClose }: Props) {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            aria-labelledby="about-us-dialog-title"
            aria-describedby="about-us-dialog-description"
            sx={{
                '& .MuiDialog-paper': {
                    borderRadius: 8, // Makes the dialog more rounded
                    minWidth: '90vw',
                    minHeight: '70vh',
                    p: 1,
                    backgroundColor: 'rgb(255, 223, 253)',

                }
            }}
        >
            <DialogTitle
                style={{
                    fontFamily: '"Berkshire Swash", "Georgia", serif',
                    fontSize: 24,
                    textShadow: "1px 1px 2px #543a3a"
                    // fontWeight:400

                }}
            >
                OM SIDAN
            </DialogTitle>
            <Divider
                sx={{
                    width: '90%',
                    alignSelf: 'center',
                    height: 1.5,
                    backgroundColor: '#8a6c88',
                }}
            />
            <DialogContent>

                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 10,
                        alignItems: 'flex-start',
                        paddingLeft: 2,
                    }}
                >

                    <p style={pStyleJustified}><strong>vadhandlas.se</strong> är en enkel liten inköpslistapp att dela med dina älsklingar,
                        roomies, föräldrar, otacksamma ungar. Lägg till,
                        ta bort och kasta om ordningen på dina planerade inköp (inga suddigum behövs, syns lika tydligt som bläck).
                        Sen kan du slänga iväg en Whatsapp-notis för att låta dina listkompisar
                        veta att det fattas mjölk till pannkakorna. Det finns en knapp för det :)
                    </p>

                    <p style={pStyleJustified}>
                        <strong>Webbsidan</strong> är kodad med <a style={aStyle} href="https://react.dev/" target="_blank" rel="noopener noreferrer">React</a> och
                        använder <a style={aStyle} href="https://supabase.com/" target="_blank" rel="noopener noreferrer">Supabase</a> som lagringstjänst,
                        hostas hos <a style={aStyle} href="https://vercel.com/" target="_blank" rel="noopener noreferrer">Vercel</a>.
                        För mig har det mest varit ett kul litet kodprojekt, och en praktisk lösning på ett konstant
                        vardagsproblem för mig och min pojkvän: vad behöver vi handla egentligen?
                    </p>

                    <p style={pStyleJustified}>
                        <strong>Fler har velat använda appen,</strong> så nu har jag öppnat för vem som helst 
                        att skaffa ett konto. Bara logga in och skapa en listgrupp för dig och dina kära. 
                        Efter det är det fritt fram att fundera på hur många tomater som fattas i kylskåpet.
                    </p>

                    <p style={pStyleJustified}>
                        <strong>Inga pengar tjänas!</strong> Fritt från reklam! Nya uppdateringar kommer ... Önskar du något eller har förslag på förbättringar är det bara att skriva till <a style={aStyle} href="mailto:ida@bergenholtz.se">ida@bergenholtz.se</a> :)
                    </p>
                    <p style={pStyle}>
                        <strong>Allt gott/</strong> din adminstratör (Ida, glad tjej i Lund, upptagen)
                    </p>

                </div>

            </DialogContent>
            <DialogActions>
                <Button 
                    sx={{
                        color:'#3f104b',
                        fontFamily:'ui-rounded',
                        textShadow: "0.5px 0.5px 1px #543a3a"
                    }}
                    onClick={onClose}
                >
                    Ok
                </Button>
            </DialogActions>
        </Dialog>
    )
}